module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sofia-samardich-5659a1469150a62f766bb9ac8b93c1e2.jpg";